import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import { SystemForm, mountForm, unmountForm } from '@kineticdata/react';
import { generateFormButtons, FormError, TableField } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';

const formKey = 'system-setup-configuration';

regRoute('SYSTEM_CONFIG_PAGE', '/system/setup/config');

regSaga(
  takeEvery('ENTER_SYSTEM_CONFIG_PAGE', function* () {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_CONFIG_PAGE', function* () {
    yield call(unmountForm, formKey);
  }),
);

export const SystemSetupConfig = () => (
  <div className="content-container">
    <SystemForm
      formKey={formKey}
      components={{
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Update System',
        }),
      }}
      alterFields={{
        allowedSystemIps: {
          component: TableField,
        },
      }}
    >
      {({ form }) => form}
    </SystemForm>
  </div>
);
